<template>
	<div class="com-list-content">
		<!-- <com-search :model="search" :transfer-model.sync="condition" v-slot="{data}" :table="$refs.table">
			<ui-text v-model="data.createTime" label="创建时间"/>
			<ui-template>
				<ui-button type="search"></ui-button>
			</ui-template>
		</com-search> -->
		<com-table ref="table" url="/admin/paper/list" :search="condition" v-slot="{data}">
			<ui-text v-model="data.id" label="ID" width="100"/>
			<ui-text v-model="data.title" label="试卷名称"/>
			<ui-text v-model="data.subjectName" label="科目"/>
			<ui-text v-model="data.userName" label="用户"/>
			<ui-date v-model="data.createTime" type="datetime" label="创建时间"/>
			<ui-template label="操作">
<!--				<ui-button type="edit" @click="edit(data)"/>-->
				<ui-button type="delete" @click="remove(data)"/>
			</ui-template>
		</com-table>
	</div>
</template>

<script>
export default {
	data(){
		return {
			search:{},
			condition:{},
		};
	},
	mounted(){
	},
	methods:{
		edit(data){
			this.$dialog('paper_detail',{type:'edit',data:data},()=>{
				this.$refs.table.refresh();
			})
		},
		remove(data){
			this.$axios.delete('/admin/paper/option/'+data.id)
			.then(data=>{
				this.$refs.table.refresh();
			}).end();
		}
	}
}
</script>

<style>
</style>
